import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-role-unauthorize',
  templateUrl: './role-unauthorize.component.html',
  styleUrls: ['./role-unauthorize.component.scss']
})
export class RoleUnauthorizedComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  ON_PREMISES_CAS = environment.ON_PREMISES_CAS;
  ON_PREMISES = environment.ON_PREMISES;
  ON_CLOUD = environment.ON_CLOUD;
  PROFILE = environment.ENV_ACTIVE_PROFILE;
  backgroundImage: string;

  constructor(private oauthService: OAuthService,) { }

  ngOnInit(): void {
    this.backgroundImage = this.RESOURCE_SERVER_URL + "/assets/Images/Login_BG.jpg"
  }
  doLogout(value) {
    let profile = value;
    localStorage.clear();
    sessionStorage.clear();
    console.log('dologout from role')
    // OIDC enviroment (OKTA,o Auth0, etc....)
    if (this.PROFILE === this.ON_PREMISES) {
      this.oauthService.logOut();
    }
    else if (profile == this.ON_CLOUD) {
      let logOut = environment.COGNITO.logoutURL + "?client_id=" + environment.COGNITO.ClientId + "&logout_uri=" + environment.COGNITO.CAS_SERVER_URL + '?serviceurl=' + environment.COGNITO.landingLogout
      window.open(logOut, '_self');
    }
    // CAS environment
    else if (profile == this.ON_PREMISES_CAS) {
      window.open(environment.OAUTH2_CAS.logoutURL, '_self');
    }
  }

}
